import dayjs from 'dayjs';
import { VesselInformationMainEnum, VesselMainDataById, VesselMainPayloadAPI } from '../mainTypes.d';
import { VesselInformationFields } from '../type';
import { convertDate } from '../../../../utils/CommonFunctions';

export function setValues(vesselMainData:VesselMainDataById, setValue: SetValue) {
  setValue(VesselInformationMainEnum.vessel, vesselMainData?.VesselName);
  setValue(VesselInformationMainEnum.testEnd, vesselMainData?.TestEndId);
  setValue(VesselInformationMainEnum.tubeType, vesselMainData?.TubeTypeId);
  setValue(VesselInformationMainEnum.material, vesselMainData?.MaterialId);
  setValue(VesselInformationMainEnum.support, vesselMainData?.SupportId);
  setValue(VesselInformationMainEnum.NWT, vesselMainData?.Nwt || '');
  setValue(VesselInformationMainEnum.NWT1, vesselMainData?.Nwt1 || '');
  setValue(VesselInformationMainEnum.NWT2, vesselMainData?.Nwt || '');
  setValue(VesselInformationMainEnum.NWT3, vesselMainData?.Nwt3 || '');
  setValue(VesselInformationMainEnum.nwtBellLand, vesselMainData?.NwtBellLand || '');
  setValue(VesselInformationMainEnum.nwtBellLand1, vesselMainData?.NwtBellLand1 || '');
  setValue(VesselInformationMainEnum.nwtBellLand2, vesselMainData?.NwtBellLand || '');
  setValue(VesselInformationMainEnum.nwtBellLand3, vesselMainData?.NwtBellLand3 || '');
  setValue(VesselInformationMainEnum.nwtUnderFins, vesselMainData?.NwtUnderFills || '');
  setValue(VesselInformationMainEnum.nwtUnderFins1, vesselMainData?.NwtUnderFills1 || '');
  setValue(VesselInformationMainEnum.nwtUnderFins2, vesselMainData?.NwtUnderFills || '');
  setValue(VesselInformationMainEnum.nwtUnderFins3, vesselMainData?.NwtUnderFills3 || '');
  setValue(VesselInformationMainEnum.probeDiameter, vesselMainData?.ProbeDiameter || '');
  setValue(VesselInformationMainEnum.probeDiameter1, vesselMainData?.ProbeDiameter1 ?? '');
  setValue(VesselInformationMainEnum.probeDiameter2, vesselMainData?.ProbeDiameter ?? '');
  setValue(VesselInformationMainEnum.probeDiameter3, vesselMainData?.ProbeDiameter3 ?? '');
  setValue(VesselInformationMainEnum.OD, vesselMainData?.Od || '');
  setValue(VesselInformationMainEnum.OD1, vesselMainData?.Od || '');
  setValue(VesselInformationMainEnum.OD2, vesselMainData?.Od2 || '');
  setValue(VesselInformationMainEnum.OD3, vesselMainData?.Od3 || '');
  setValue(VesselInformationMainEnum.tubeCount, vesselMainData?.TubeCount);
  setValue(VesselInformationMainEnum.tubeLength, vesselMainData?.TubeLength);
  setValue(VesselInformationMainEnum.analyst, vesselMainData?.AnalystId);
  setValue(VesselInformationMainEnum.inspectionDate, dayjs(convertDate(vesselMainData?.InspectionDate || '')));
  setValue(VesselInformationMainEnum.retestDate, dayjs(convertDate(vesselMainData?.RetestDate || '')));
}

export function getPayload(data: VesselInformationFields, vesselMainData: VesselMainDataById): VesselMainPayloadAPI {
  return {
    Id: vesselMainData.Id,
    VesselId: vesselMainData.VesselId,
    JobOrder: vesselMainData.JobOrder,
    RecordId: `${vesselMainData.JobOrder}-${vesselMainData.VesselId}`,
    // RecordId: String(data.vessel),
    TestEndId: Number(data.testEnd),
    TubeTypeId: Number(data.tubeType),
    MaterialId: Number(data.material),
    SupportId: Number(data.support),
    Od: vesselMainData.IsMultiOffset ? Number(data.OD1) : Number(data.OD),
    Od2: String(data.OD2),
    Od3: String(data.OD3),
    Nwt: vesselMainData.IsMultiOffset ? Number(data.NWT2) : Number(data.NWT),
    Nwt1: Number(data.NWT1),
    Nwt3: Number(data.NWT3),
    NwtBellLand: vesselMainData.IsMultiOffset ? Number(data.NWTBellLand2) : Number(data.NWTBellLand),
    NwtBellLand1: Number(data.NWTBellLand1),
    NwtBellLand3: Number(data.NWTBellLand3),
    NwtUnderFills: vesselMainData.IsMultiOffset ? Number(data.NWTUnderFins2) : Number(data.NWTUnderFins),
    NwtUnderFills1: Number(data.NWTUnderFins1),
    NwtUnderFills3: Number(data.NWTUnderFins3),
    AnalystId: data.analyst,
    InspectionDate: dayjs(data.inspectionDate).format('DD-MM-YYYY'),
    RetestDate: dayjs(data.retestDate).format('DD-MM-YYYY'),
    ProbeDiameter: vesselMainData.IsMultiOffset ? Number(data.probeDiameter2) : Number(data.probeDiameter),
    ProbeDiameter1: Number(data.probeDiameter1),
    ProbeDiameter3: Number(data.probeDiameter3),
    TubeCount: String(data.tubeCount),
    TubeLength: Number(data.tubeLength),
    TubeNumbering: true,
  };
}
